<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">补充材料</div>
      <blue-title class="style">补充材料</blue-title>
      <div>
        <div class="info" style="height: 70px">
          <span class="marRight">法人开户承诺函</span
          ><span
            ><el-image :src="supplementData.legalPersonCommitment" alt="" style="width: 58px; height: 58px"></el-image
          ></span>
        </div>
        <!-- <div class="info" style="height: 70px">
          <span class="marRight">法人开户意愿视频</span
          ><span
            ><el-image
              src="http://tupian201805.oss-cn-beijing.aliyuncs.com/2022/1/10/1644484450446_58155aa381764d188fbd8580c4bcc199.jpeg"
              alt=""
              style="width: 58px; height: 58px"
            ></el-image
          ></span>
        </div> -->
        <div class="info" style="height: 70px">
          <span class="marRight">补充材料</span
          ><span
            ><el-image :src="supplementData.businessAdditionPics" alt="" style="width: 58px; height: 58px"></el-image
          ></span>
        </div>
        <div class="info">
          <span class="marRight">补充说明</span><span>{{ supplementData.businessAdditionMsg }}</span>
        </div>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';

export default {
  components: {},
  props: {},
  data() {
    return {
      supplementData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.supplementData = result.supplementaryMaterialsVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    line-height: 16px;
    width: 90px;
    margin-right: 38px;
  }
  .btn {
    margin-top: 100px;
  }
}
</style>
